var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_ClaimBalance_form_dialog_viewClaimTransactionTitle"
      ),
      dialog: _vm.show,
      width: "700",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_ClaimBalance_form_dialog_claimTypeLabel",
                            items: _vm.claimType,
                            readonly: !_vm.isEdited,
                            "item-text": "claim_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.TransactionsData.claim_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "claim_type_uuid",
                                $$v
                              )
                            },
                            expression: "TransactionsData.claim_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_ClaimBalance_form_dialog_transactionTypeLabel",
                            readonly: !_vm.isEdited,
                            filled: false,
                            items: _vm.Transactiontype,
                            disabled: !_vm.TransactionsData.claim_type_uuid,
                            "item-text": "claim_transaction_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value:
                              _vm.TransactionsData.claim_transaction_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "claim_transaction_type_uuid",
                                $$v
                              )
                            },
                            expression:
                              "TransactionsData.claim_transaction_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "month",
                            readonly: !_vm.isEdited,
                            filled: false,
                            defaultTime: _vm.TransactionsData.claim_period,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimBalance_form_dialog_claimPeriodLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.claim_period = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "\n              white--text\n              rounded-lg\n              pa-3\n              subtitle-1\n              d-flex\n              justify-space-between\n            ",
                            attrs: { color: "primary" },
                          },
                          [
                            _c("div", { staticClass: "max-width" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_ClaimBalance_form_dialog_totalAmountLabel"
                                    )
                                  ) +
                                  ": "
                              ),
                            ]),
                            _c("div", { staticClass: "max-width text-right" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.TransactionsData.currency_code) +
                                  " " +
                                  _vm._s(
                                    parseFloat(
                                      Number(_vm.TransactionsData.total_amount)
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span"),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            readonly: !_vm.isEdited,
                            filled: false,
                            defaultTime:
                              _vm.TransactionsData.effective_utc_datetime,
                            max: _vm.TransactionsData.expired_utc_datetime,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimBalance_form_dialog_effectiveStartDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.effective_utc_datetime =
                                time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            readonly: !_vm.isEdited,
                            filled: false,
                            defaultTime:
                              _vm.TransactionsData.expired_utc_datetime,
                            min: _vm.TransactionsData.effective_utc_datetime,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimBalance_form_dialog_expiredDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.expired_utc_datetime =
                                time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_ClaimBalance_form_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            readonly: !_vm.isEdited,
                            filled: false,
                          },
                          model: {
                            value: _vm.TransactionsData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.TransactionsData, "remarks", $$v)
                            },
                            expression: "TransactionsData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }